import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import dayjs from 'dayjs';
import esUs from 'dayjs/locale/es-us';
import isDev from './util/isDev';

import App from './components/_app/App';
import Admin from './components/_admin/Admin';
import Amazon from './components/_amazon/Amazon';
import NotFound from './components/not-found/NotFound';

import withClearCache from './util/ClearCache';

const ClearCacheComponent = withClearCache(SubdomainManager);

function MainApp() {
  return <ClearCacheComponent />;
}

function SubdomainManager() {
  // Fixing spanish language on dayjs
  dayjs.locale('es-MX', {
    ...esUs,
    weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
    weekdaysShort: 'Dom_Lun_Mar_Mie_Jue_Vie_Sab'.split('_'),
    weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_'),
    months:
      'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
        '_'
      ),
    monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
  });

  return (
    <Router>
      <Route
        path="/"
        render={(props) => {
          if (isDev() && isMobile) {
            // *** For Mobile Development ***
            return <App {...props} />;
            // return <Admin {...props} />;
            // return <Amazon {...props} />;
          }

          const subdomain = window.location.hostname.split('.');
          if (subdomain && subdomain.length === 3) {
            switch (subdomain[0]) {
              case 'app':
                return <App {...props} />;
              case 'admin':
                return <Admin {...props} />;
              case 'amazon':
                return <Amazon {...props} />;
              default:
                return <NotFound setShowNavbar={null} />;
            }
          }
          // return <NotFound setShowNavbar={null} />; // This is temp
          return null;
        }}
      />
    </Router>
  );
}

export default MainApp;
